import { MutationFn, UseQueryFn } from 'shared-ui';

import { StrefyResponse } from 'api/strefy/strefy.types';

import {
  AttendanceTimeReportRequest,
  EventsReportRequest,
  InneEventsReportRequest,
  IssuedCardsReportRequest,
  OwnersWithoutEventsReportRequest,
  PermissionsSummaryReportRequest,
  PresentOwnersReportRequest,
} from './reports.types';

export const downloadPermissionsSummaryReport: MutationFn<PermissionsSummaryReportRequest, Blob> = (body) => {
  return {
    endpoint: '/report/uprawnienia',
    method: 'POST',
    body,
    responseType: 'arraybuffer',
  };
};

export const downloadIssuedCardsReport: MutationFn<IssuedCardsReportRequest, Blob> = (body) => {
  return {
    endpoint: '/report/wydane-karty',
    method: 'POST',
    body,
    responseType: 'arraybuffer',
  };
};

export const downloadEventsReport: MutationFn<EventsReportRequest, Blob> = (body) => {
  return {
    endpoint: '/report/zdarzenia',
    method: 'POST',
    body,
    responseType: 'arraybuffer',
  };
};

export const downloadOwnersWithoutEventsReport: MutationFn<OwnersWithoutEventsReportRequest, Blob> = (body) => {
  return {
    endpoint: '/report/posiadacze-bez-zdarzen',
    method: 'POST',
    body,
    responseType: 'arraybuffer',
  };
};

export const downloadAttendanceTimeReport: MutationFn<AttendanceTimeReportRequest, Blob> = (body) => {
  return {
    endpoint: '/report/czas-obecnosci',
    method: 'POST',
    body,
    responseType: 'arraybuffer',
  };
};

export const downloadInneEventsReport: MutationFn<InneEventsReportRequest, Blob> = (body) => {
  return {
    endpoint: '/report/zdarzenia-inne',
    method: 'POST',
    body,
    responseType: 'arraybuffer',
  };
};

export const downloadPresentOwnersReport: MutationFn<PresentOwnersReportRequest, Blob> = (body) => {
  return {
    endpoint: '/report/osoby-obecne',
    method: 'POST',
    body,
    responseType: 'arraybuffer',
  };
};

/** Zone tree for the report's Strefa filter — `GET /strefa` needs DEFINICJE:VIEW, this one the report permission. */
export const fetchPresentOwnersReportZones: UseQueryFn<null, StrefyResponse> = () => {
  return {
    endpoint: '/report/osoby-obecne/strefy',
  };
};
